import { DateTime } from "luxon";

export class DateTimeValue {
  static DTFORMAT = "yyyy-MM-dd'T'HH:mm:ssZZ";
  static DFORMAT = "yyyy-MM-dd";
  static TFORMAT = "HH:mm:ss";

  date = null;
  time = null;

  constructor(date, time) {
    this.date = date || null;
    this.time = time || null;
  }

  getDate() {
    return this.date;
  }

  getTime() {
    return this.time;
  }

  toJson(defaultTime = null) {
    if (this.date !== null) {
      if (this.time !== null)
        return DateTime.fromISO(this.date + "T" + this.time).toFormat(DateTimeValue.DTFORMAT);
      else if (defaultTime !== null)
        return DateTime.fromISO(this.date + "T" + defaultTime).toFormat(DateTimeValue.DTFORMAT);
      else
        return DateTime.fromFormat(this.date, "yyyy-MM-dd").toFormat(DateTimeValue.DFORMAT);
    } else
      return null;
  }

  static fromString(str) {
    if (str === undefined || str === null)
      return new DateTimeValue(null, null);

    const dt = DateTime.fromISO(str)
    return new DateTimeValue(dt.toFormat(DateTimeValue.DFORMAT), dt.toFormat(DateTimeValue.TFORMAT));
  }
}